// src/pages/Status.jsx
import SEO from "../components/SEO.jsx";
import Footer from "../components/layout/footer.jsx";
import {SparklesIcon} from "@heroicons/react/24/outline";
import React from 'react';
import { Link } from 'react-router-dom';

export function Status() {
    return (
        <>
            <SEO
                title="System Status - PostMgr"
                description="Current status of PostMgr services and any ongoing maintenance or incidents."
                url="https://postmgr.com/status"
            />

            <div className="min-h-screen bg-gray-50">
                <nav className="bg-white shadow-sm">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between h-16">
                            <div className="flex items-center">
                                <Link to="/" className="flex items-center">
                                    <img src="/images/Bob_only.svg" alt="PostMgr" className="h-8 w-8" />
                                    <span className="ml-2 text-2xl font-bold text-blue-600">PostMgr</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </nav>

                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">System Status</h1>
                        <div className="inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-full">
                            <span className="w-2 h-2 bg-green-600 rounded-full mr-2"></span>
                            All Systems Operational
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm p-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-6">Current Status</h2>

                        <div className="space-y-4">
                            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                <div>
                                    <h3 className="font-semibold text-gray-900">API Services</h3>
                                    <p className="text-sm text-gray-600">Core API functionality</p>
                                </div>
                                <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Operational</span>
                            </div>

                            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                <div>
                                    <h3 className="font-semibold text-gray-900">AI Content Generation</h3>
                                    <p className="text-sm text-gray-600">OpenAI and Gemini services</p>
                                </div>
                                <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Operational</span>
                            </div>

                            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                <div>
                                    <h3 className="font-semibold text-gray-900">Social Media Publishing</h3>
                                    <p className="text-sm text-gray-600">LinkedIn, Instagram, Twitter integration</p>
                                </div>
                                <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Operational</span>
                            </div>

                            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                <div>
                                    <h3 className="font-semibold text-gray-900">Web Dashboard</h3>
                                    <p className="text-sm text-gray-600">Main application interface</p>
                                </div>
                                <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Operational</span>
                            </div>
                        </div>

                        <div className="mt-8">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Updates</h3>
                            <div className="text-sm text-gray-600">
                                <p>No recent incidents to report. All systems running smoothly.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default Status;